import { render } from "./PaychanguCardDepositWebsite.vue?vue&type=template&id=11c9452a&scoped=true"
import script from "./PaychanguCardDepositWebsite.vue?vue&type=script&lang=js"
export * from "./PaychanguCardDepositWebsite.vue?vue&type=script&lang=js"

import "./PaychanguCardDepositWebsite.vue?vue&type=style&index=0&id=11c9452a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c9452a"]])

export default __exports__